export const NORTHWELL_ALIBI_URL = 'https://northwell.private.dev.midassecure.com/api';
export const NORTHWELL_CZ_URL = 'https://controlzone-northwell.dev.midassecure.com';
